import React from 'react';
import { Sparkles } from 'lucide-react';

interface ZodiacSign {
    name: string;
    image: string;
    dates: string;
    element: string;
}

import { HOROSCOPE_TRANSLATIONS } from '../../../../languages/horoscope';

interface SignSelectorProps {
    signs: ZodiacSign[];
    selectedSign: string;
    onSelectSign: (name: string) => void;
    periodInfo?: string;
    language: string;
}

const SignSelector: React.FC<SignSelectorProps> = ({ signs, selectedSign, onSelectSign, periodInfo, language }) => {
    const langKey = language === 'hindi' ? 'Hindi' : 'English';
    const t = HOROSCOPE_TRANSLATIONS[langKey];

    return (
        <div className="mb-16 pt-4">
            <div className="flex overflow-x-auto overflow-y-visible pb-6 pt-4 gap-4 justify-start md:justify-center px-4 no-scrollbar snap-x">
                {signs.map((sign, index) => (
                    <button
                        key={sign.name}
                        onClick={() => onSelectSign(sign.name)}
                        className={`relative flex-shrink-0 w-24 md:w-28 group snap-center rounded-2xl border p-3 md:p-4 transition-colors duration-300 ${selectedSign === sign.name
                            ? 'bg-gradient-to-br from-purple-900/80 to-indigo-900/80 border-purple-400/50 shadow-[0_0_20px_rgba(168,85,247,0.3)] transform -translate-y-2 z-10'
                            : 'bg-white/[0.08] border-white/20 hover:bg-white/[0.12] hover:border-white/20 z-0'
                            }`}
                    >
                        <div className={`absolute -top-2 -right-2 w-6 h-6 rounded-full bg-cosmic-950 border border-white/20 flex items-center justify-center transition-opacity ${selectedSign === sign.name ? 'opacity-100' : 'opacity-0'
                            }`}>
                            <Sparkles size={12} className="text-yellow-400" />
                        </div>
                        <div className="w-16 h-16 md:w-20 md:h-20 mx-auto mb-2 relative">
                            <img
                                src={sign.image}
                                alt={sign.name}
                                className="w-full h-full object-contain drop-shadow-lg group-hover:scale-110 transition-transform duration-300"
                            />
                        </div>
                        <div className="text-center font-sans">
                            <div className="text-xs md:text-sm font-bold text-white mb-0.5">{t[sign.name] || sign.name}</div>
                            <div className="text-[10px] text-purple-300/60 line-clamp-1">{periodInfo || sign.dates}</div>
                        </div>
                        <div className={`absolute bottom-2 left-1/2 -translate-x-1/2 w-8 h-0.5 rounded-full transition-colors ${selectedSign === sign.name ? 'bg-purple-400 w-12' : 'bg-transparent'
                            }`} />
                    </button>
                ))}
            </div>
        </div>
    );
};

export default SignSelector;
